import { ReactNode } from "react"
import ChessScreen from "@/components/game/ChessScreen"
import { GameProvider } from "@/hooks/useGame"
import { GameMovesProvider } from "@/hooks/useGameMoves"
import AppLayout from "@/layouts/AppLayout"
import EmbedModal from "@/modals/EmbedModal"
import SaveGameModal from "@/modals/SaveGameModal"
import ShareModal from "@/modals/ShareModal"
import { GameShowProps } from "@/types/types"
import { usePage } from "@inertiajs/react"

const GameShowPage = () => {
  const { game, isOwner } = usePage<GameShowProps>().props

  return (
    <GameMovesProvider mode={game.draft ? "draft" : "default"}>
      <GameProvider>
        <ChessScreen isOwner={isOwner} />
        {isOwner && (
          <>
            <SaveGameModal />
            <ShareModal
              title="Share game"
              url={`https://chessdrop.com/games/${game.id}`}
              type="game"
            />
            <EmbedModal />
          </>
        )}
      </GameProvider>
    </GameMovesProvider>
  )
}

export default GameShowPage

GameShowPage.layout = (page: ReactNode) => (
  <AppLayout hideTabs hideBanners>
    {page}
  </AppLayout>
)
